import { Avatar, Skeleton, Stack, Typography, useTheme } from '@mui/material'
import { useSelector } from 'react-redux'
import sparkIcon from '../../../../assets/images/share/sparkIcon.png'
import { memo } from 'react'
import { OrgSelect } from '../../../../components/Header/components/OrgSelect'
import {
    selectSchoolLogo,
    selectSchoolName,
} from '../../../../redux/schoolSlice'

const SchoolCard = () => {
    const theme = useTheme()

    const schoolLogo = useSelector(selectSchoolLogo)
    const schoolName = useSelector(selectSchoolName)

    return (
        <Stack
            sx={{
                width: '100%',
                p: 3,
                borderRadius: '24px',
                backgroundColor: theme.palette.neutrals[50],
                gap: 1.5,
                alignItems: 'center',
                // textAlign: 'center',
            }}
        >
            {/* Logo */}
            {schoolLogo === undefined ? (
                <Skeleton variant="circular">
                    <Avatar sx={{ height: 80, width: 80 }} />
                </Skeleton>
            ) : (
                <Avatar
                    src={schoolLogo || sparkIcon}
                    sx={{ height: 80, width: 80 }}
                />
            )}

            {/* Content */}
            <Stack gap={1}>
                <Typography variant="h6" fontWeight={600} textAlign={'center'}>
                    {schoolName}
                </Typography>
                <Typography variant="ps" textAlign={'center'}>
                    Switch campuses below
                </Typography>
                <OrgSelect
                    controlProps={{
                        variant: 'outlined',
                        sx: {
                            backgroundColor: theme.palette.shades[0],
                            borderRadius: '40px',
                        },
                    }}
                    selectProps={{
                        slotProps: {
                            input: { sx: { ...theme.typography.pxs } },
                        },
                    }}
                />
            </Stack>
        </Stack>
    )
}

export default memo(SchoolCard)
